import { Component, OnInit, Input } from '@angular/core';
import { RoutingHistoryService } from '../../../services/routing-history.service';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent implements OnInit {

  @Input() img: string;
  @Input() showLabel: boolean = true;
  @Input() isRedesign: boolean = false;
  queryParams: { [key: string]: any; };
  url: any;
  text: Observable<string>;
  disabled: boolean = false;

  constructor(private historyService: RoutingHistoryService) { }

  ngOnInit() {
    // need to subscribe to event in case the historyService sets new route when routing back to a listing page
    this.historyService.historyItemChangedEvent.pipe(take(1)).toPromise().then(() => {
      this.setReturnUrl();
    });
    this.setReturnUrl();
  }

  setReturnUrl() {
    this.text = this.historyService.backToText;
    const returnURL = this.historyService.returnUrl;
    this.url = (returnURL != null ? returnURL : ['/find-real-estate'])
    this.queryParams = this.historyService.returnQueryParams;
  }

  goBack() {
    if (!this.disabled) {
      this.historyService.pop();
    }
    // prevent double click from removing more history than it should
    this.disabled = true;
  }
}
